import Vue from "vue";
import Router from "vue-router";
//import Home from './views/Home.vue';
import apiEndpoints from "./mixins/api-endpoints";

// import views for eager loading
import LogIn from "./views/LogIn.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import ResetPassword from "./views/ResetPassword.vue";
import Home from "./views/Home.vue";
import Locked from "./views/Locked.vue";
import Log from "./views/Log.vue";
import DeviceInfo from "./views/DeviceInfo.vue";
import MyDevices from "./views/MyDevices.vue";
import AllDevices from "./views/AllDevices.vue";
import DownloadDeviceReadings from "./views/DownloadDeviceReadings.vue";
import UsbDevice from "./views/UsbDevice.vue";
import Device from "./views/Device.vue";
import DeviceAdminList from "./views/DeviceAdminList.vue";
import UsbDeviceStatus from "./views/UsbDeviceStatus.vue";
import Calibrate from "./views/Calibrate.vue";
import UsbDeviceTest from "./views/UsbDeviceTest.vue";
import ViewFlashContent from "./views/ViewFlashContent.vue";
import MyProfile from "./views/MyProfile.vue";
import Groups from "./views/Groups.vue";
import Users from "./views/Users.vue";
import Offline from "./views/Offline.vue";
import MultiDeviceSelection from "./views/MultiDeviceSelection.vue";
import CreateLink from "./views/CreateLink.vue";
import store from "./store";
import MultiGraphPage from "./views/MultiGraphPage.vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "login",
            component: LogIn
        },
        {
            path: "/forgot_password",
            name: "forgot_password",
            component: ForgotPassword
        },
        {
            path: "/password/reset/:token",
            name: "reset_password",
            component: ResetPassword
        },
        {
            path: "/home",
            name: "home",
            component: Home
        },
        {
            path: "/locked",
            name: "locked",
            component: Locked
        },
        {
            path: "/log/:id",
            name: "log",
            component: Log
        },
        {
            path: "/link/:token",
            name: "link",
            component: Log
        },
        {
            path: "/deviceinfo/:id",
            name: "deviecinfo",
            component: DeviceInfo
        },
        {
            path: "/my_devices",
            name: "my_devices",
            component: MyDevices
        },
        {
            path: "/multi_devices",
            name: "multi_devices",
            component: MultiDeviceSelection
        },
        {
            path: "/all_devices",
            name: "all_devices",
            component: AllDevices
        },
        {
            path: "/download_readings/:deviceId",
            name: "download_readings",
            component: DownloadDeviceReadings
        },
        {
            path: "/multi_graph",
            name: "multi_graph",
            //component: MultiGraphPage
            component: Log
        },
        {
            path: "/usbdevice/:id",
            name: "usbdevice",
            component: UsbDevice
        },
        {
            path: "/device/:id",
            name: "device",
            component: Device
        },
        {
            path: "/devices",
            name: "devices",
            component: DeviceAdminList
        },
        {
            path: "/usbdevicetest/:id",
            name: "usbdevicetest",
            component: UsbDeviceTest
        },
        {
            path: "/usbdevicestatus/:id",
            name: "usbdevicestatus",
            component: UsbDeviceStatus
        },
        {
            path: "/calibrate",
            name: "calibrate",
            component: Calibrate
        },
        {
            path: "/viewflash/:id",
            name: "viewflash",
            component: ViewFlashContent
        },
        {
            path: "/profile",
            name: "profile",
            component: MyProfile
        },
        {
            path: "/groups",
            name: "groups",
            component: Groups
        },
        {
            path: "/users",
            name: "users",
            component: Users
        },
        {
            path: "/offline",
            name: "offline",
            component: Offline
        },
        {
            path: "/create_link/:id",
            name: "create_link",
            component: CreateLink
        },
        {
            // redirect to welcome page on notfound
            path: "*",
            name: "notfound",
            component: LogIn.vue
        }
    ]
});

// redirect to login page if not authenticated.
router.beforeEach((to, from, next) => {
    let user = apiEndpoints.methods.loadToken();
    console.log("from: " + from.path);

    console.log("to: " + to.path);
    let publicRoutes = ["login", "reset_password"];

    if (!store.state.networkAvailable) {
        if (
            apiEndpoints.data().offlineRoutes.includes(to.name) ||
            to.name == "home"
        ) {
            console.log("calling next on not connected");
            next();
        } else {
            next("/home");
        }
    } else if (to.name == "login") {
        if (user) {
            console.log("Redirecting to '/home'");
            next("/home");
        } else {
            console.log("Plainly calling next(1).");
            next();
        }
    } else if (
        to.name == "reset_password" ||
        to.name == "forgot_password" ||
        to.name == "link"
    ) {
        console.log("Plainly calling next for " + to.name);
        next();
    } else if (!user && to.path != "/") {
        console.log("Redirecting to '/'");
        next("/");
    } else {
        console.log("Plainly calling next(2)");
        next();
    }
});

export default router;
